module.exports = __webpack_public_path__ + "img/22.8e8e5498.jpg";